import { Directive } from '@angular/core';

@Directive({
  selector: '[treeNodeDef]'
})
export class TreeNodeDefDirective {

  constructor() { }

}
